module.exports = __webpack_public_path__ + "img/done-check-white.faa6573d.svg";